import styled from 'styled-components';

export const CalendarStyle = styled.div(props => ({
    display: "flex",
    flexDirection: "column",
    flex: "1"
}));